import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useDispatch, useSelector } from '@spcc/core'
import {
  KioskScanSection,
  selectScannedOrder,
} from '@spcc/domains/shipments'
import {
  queueActions,
  selectJoinError,
  selectJoinExistingEntry,
  selectJoinLoading,
  selectJoinResult,
} from '@spcc/domains/queue'
import {
  kioskConfigActions,
  selectIsPlantQueueClosed,
} from '@/store/kiosk-config.slice'

export const Route = createFileRoute('/scan')({
  component: ScanPage,
})

function ScanPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const scannedOrder = useSelector(selectScannedOrder)
  const joinLoading = useSelector(selectJoinLoading)
  const joinError = useSelector(selectJoinError)
  const joinResult = useSelector(selectJoinResult)
  const joinExistingEntry = useSelector(selectJoinExistingEntry)

  const plantDocumentId = scannedOrder?.order.factory?.documentId ?? null
  const packaging = scannedOrder?.variant?.packaging ?? null
  const plantQueueClosed = useSelector((state) =>
    selectIsPlantQueueClosed(
      state as Parameters<typeof selectIsPlantQueueClosed>[0],
      plantDocumentId,
      packaging,
    ),
  )
  // ADS runs the gate at one plant, and that plant has no queue at all — so it
  // can never be "closed". Without this the closed-queue banner would stop the
  // scan from ever reaching ADS, and nobody would think to reopen a queue that
  // does not exist.
  const isAdsPlant = scannedOrder?.order.factory?.gateSystem === 'ads'
  const isQueueClosed = plantQueueClosed && !isAdsPlant

  const scannedOrderId = scannedOrder?.order.documentId ?? null

  useEffect(() => {
    dispatch(kioskConfigActions.fetchKioskConfig())
  }, [dispatch])

  useEffect(() => {
    dispatch(queueActions.clearJoinResult())
  }, [dispatch, scannedOrderId])

  return (
    <KioskScanSection
      onBack={() => navigate({ to: '/' })}
      onJoinQueue={(payload) => dispatch(queueActions.joinQueue(payload))}
      isJoiningQueue={joinLoading}
      joinError={joinError}
      joinResult={joinResult}
      existingQueueEntry={joinExistingEntry}
      isQueueClosed={isQueueClosed}
    />
  )
}

